export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8956.b6676f05.jpg";